import { Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EReplyStatus } from 'src/app/models/recipients.model';
import { toSignal } from '@angular/core/rxjs-interop';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'que-status-to-user-filter',
    imports: [CommonModule, TranslateDirective, TranslatePipe],
    templateUrl: './status-to-user-filter.component.html',
    styleUrls: ['./status-to-user-filter.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: StatusToUserFilterComponent, multi: true }]
})
export class StatusToUserFilterComponent implements ControlValueAccessor, OnInit {
  enumQStatus = EReplyStatus;
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  statusList = [
    {
      status: EReplyStatus.NotStarted,
      choosed: false
    },
    {
      status: EReplyStatus.InProgress,
      choosed: false
    },
    {
      status: EReplyStatus.Finished,
      choosed: false
    },
      {
      status: EReplyStatus.PendingApproval,
      choosed: false
    },
        {
      status: EReplyStatus.Approved,
      choosed: false
    },
        {
      status: EReplyStatus.Rejected,
      choosed: false
    },
  ];

  ngOnInit() {
    this.statusList.map(x => this.selectedFilter$()?.statusToUser?.includes(x.status)? x.choosed = true : false)    
  }


  
  valueControl = new FormControl<EReplyStatus[] | null>(null);
  callBackFunction: Function = () => { };

  writeValue(obj: any): void {
    this.valueControl.setValue(obj);
  }

  registerOnChange(fn: any): void {
    this.callBackFunction = fn;
  }

  registerOnTouched(fn: any): void {
    // throw new Error('Method not implemented.');
  }

  selectStatus(item: any) {    
    item.choosed = !item.choosed;
    const itemsSelected = this.statusList.filter(x => x.choosed == true).map(x => { return x.status });
    this.valueControl.setValue(itemsSelected);
    if (this.callBackFunction) {
      this.callBackFunction(this.valueControl.value);
    }
  }
}
